import { AppColors } from 'src/resources/app_colors';
import { AppIcons } from 'src/resources/app_icons';

const fallbackBaseUrl = 'https://focali-uat.speehive.net';
const baseUrl = typeof window !== 'undefined' ? window.location.origin : fallbackBaseUrl;

const invoiceParserBaseUrl = 'https://fi-invoice-parser-uat.azurewebsites.net/';
const invoiceParserKey = 'f47ac10b-58cc-4372-a567-0e02b2c3d479';

const baseWarehouseAppUrl = 'https://focal-uat-warehouse.azurewebsites.net/';

export const environment = {
  appVersion: require('../../package.json').version + '-uat',

  primaryColor: '#FFD080',
  secondaryColor: AppColors.primarySoftBlue,

  production: true,
  baseName: 'focali-uat',
  hostDomain: 'focali-uat.speehive.net',

  invoiceParserBaseUrl,
  baseWarehouseAppUrl,
  invoiceParserKey,

  hmr: false,

  application: {
    baseUrl,
    name: 'Focali',
    logoUrl: AppIcons.appIconPath,
  },

  oAuthConfig: {
    issuer: 'https://focali-uat-api.azurewebsites.net/',

    clientId: 'AgencyPlatform_App',

    scope: 'offline_access openid profile email roles AgencyPlatform',

    requireHttps: true,
    strictDiscoveryDocumentValidation: false,
  },

  apis: {
    default: {
      url: 'https://focali-uat-api.azurewebsites.net/',
      rootNamespace: 'AgencyPlatform',
    },
  },

  appInsights: {
    instrumentationKey: '902fb647-26d3-41dd-a2be-25906a4bfdbb',
  },

  googleAnalytics: {
    measurementId: '',
  },

  webPush: {
    publicKey:
      'BEL-O4IUpkHPn3V4vB9OX9c2o-KIq-yIT6ilzJCZ372RN_iUR18PzYxNGFCl5oJtabTHPGEguEepictUHzddolE',
    privateKey: 'ywN0xjozJYIx2HKiPaWxFC6NKNSMi7xH55Dy4k429Gg',
  },

  firebase: {
    apiKey: 'AIzaSyAF_4XjZtAlWJ1EIoZuRoLHkAlbH7HRtnM',
    authDomain: 'focali-uat-app.firebaseapp.com',
    projectId: 'focali-uat-app',
    storageBucket: 'focali-uat-app.firebasestorage.app',
    messagingSenderId: '428328114565',
    appId: '1:428328114565:web:a5cbe52c99dbe709268cec',
    measurementId: 'G-TPS22VCZ4H',
    vapidKey:
      'BOqfZEVgoF_98H56BmflVp7PClCLqyuzDEU152VH2vZPmPDwcpZZPRs1HQoIAXJwqSD4rerQ5PJf6vPp5p_tJDM',
  },
};